import { createAction } from '@reduxjs/toolkit';

export const SEND_LOGS = 'SEND_LOGS';
export const sendLogsAction = createAction(SEND_LOGS);
